module.exports = __webpack_public_path__ + "img/bana_no.3a0c1807.png";